var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C4.55228 3 5 3.44772 5 4V12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12V4C3 3.44772 3.44772 3 4 3ZM7.29302 7.29289C6.90249 7.68342 6.90249 8.31658 7.29302 8.70711L11.293 12.7071C11.6835 13.0976 12.3167 13.0976 12.7072 12.7071C13.0978 12.3166 13.0978 11.6834 12.7072 11.2929L9.41434 8L12.7072 4.70711C13.0978 4.31658 13.0978 3.68342 12.7072 3.29289C12.3167 2.90237 11.6835 2.90237 11.293 3.29289L7.29302 7.29289Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronFirst);
export default __webpack_public_path__ + "static/media/Chevron-First.e988a28e9b44d16eed89ee57e60ba949.svg";
export { ForwardRef as ReactComponent };